import { Container } from '@mui/material';
import { PageHeader } from 'components';
import { Filters, Results } from './components';
import { TicketCategoriesProvider } from './TicketCategoriesContext';


let TicketCategories = () => {
    return (
        <Container>
            <TicketCategoriesProvider>
                <PageHeader pageTitle="Categorie ticket" addNewUrl={"/ticketcategory/addnew"} />
                <Filters />
                <Results />
            </TicketCategoriesProvider>
        </Container>
    );
}

export default TicketCategories;